import React from "react";

export const Wrapper = ({ children }) => {
    return (
        <div className="">{children}</div>
    )
}